<div class="wrapper">
  <nav class="main-header navbar navbar-expand navbar-white navbar-light">
    <ul class="navbar-nav">
      <li class="nav-item">
        <a class="nav-link" data-widget="pushmenu"  role="button"><i class="fas fa-bars"></i></a>
      </li>
      <li class="nav-item d-none d-sm-inline-block">
        <a class="nav-link">{{project?.name}}</a>
      </li>
    </ul>

    <ul class="navbar-nav ml-auto">
      <li class="nav-item dropdown">
        <a class="nav-link" data-toggle="dropdown" >
          <i class="far fa-user"></i>
        </a>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
          <a  class="dropdown-item text-center">
            {{user.name}} <br>
            {{user.email}}
          </a>
          <div class="dropdown-divider"></div>
          <a  class="dropdown-item" [routerLink]="['/projects']" *ngIf="user.role === 'admin'">
            <i class="fas fa-folder mr-2"></i> Switch Project
          </a>
          <div class="dropdown-divider"></div>
          <a  class="dropdown-item" [routerLink]="['/dashboard/user']" *ngIf="user.role === 'admin' || user.role === 'manager'">
            <i class="fas fa-users mr-2"></i> Manage Users
          </a>
          <div class="dropdown-divider"></div>
          <a  class="dropdown-item dropdown-footer" (click)="logout()">Log Out</a>
        </div>
      </li>
    </ul>
  </nav>
  <aside class="main-sidebar sidebar-dark-primary elevation-4">
    <a  class="brand-link" style="text-align: center;">
      <span class="brand-text font-weight-light">Prisma<sup>CRM</sup></span>
    </a>

    <div class="sidebar">
      <nav class="mt-2">
        <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
          <li class="nav-item"  [routerLink]="['/dashboard']">
            <a  class="nav-link">
              <i class="nav-icon fas fa-tachometer-alt"></i>
              <p>
                Dashboard
              </p>
            </a>
          </li>


          <li class="nav-header"> Project</li>
          <li class="nav-item" [routerLink]="['/dashboard/inventory/settings']"  *ngIf="user.role === 'admin' || user.role === 'manager'">
            <a  class="nav-link">
              <i class="nav-icon fa fa-cog"></i>
              <p>
                Settings
              </p>
            </a>
          </li>
          <li class="nav-item" [routerLink]="['/dashboard/inventory']">
            <a  class="nav-link">
              <i class="nav-icon far fa-building"></i>
              <p>
                Inventory
              </p>
            </a>
          </li>
          <li class="nav-item" [routerLink]="['/dashboard/channel-partners']">
            <a  class="nav-link">
              <i class="nav-icon fa fa-users"></i>
              <p>
                Channel Partners
              </p>
            </a>
          </li>
          <li class="nav-header"  *ngIf="user.role === 'admin' || user.role === 'manager' || user.role === 'sales'">Sales</li>
          <li class="nav-item" [routerLink]="['/dashboard/sales/create-customer']"  *ngIf="user.role === 'admin' || user.role === 'manager' || user.role === 'sales'">
            <a  class="nav-link">
              <i class="nav-icon fa fa-plus"></i>
              <p>
                Add Customer
              </p>
            </a>
          </li>
          <li class="nav-item" [routerLink]="['/dashboard/sales/customers']"  *ngIf="user.role === 'admin' || user.role === 'manager' || user.role === 'sales'">
            <a  class="nav-link">
              <i class="nav-icon far fa-user"></i>
              <p>
                Customers
              </p>
            </a>
          </li>
          <li class="nav-item" [routerLink]="['/dashboard/sales/payments']"  *ngIf="user.role === 'admin' || user.role === 'manager' || user.role === 'account'">
            <a  class="nav-link">
              <i class="nav-icon fas fa-columns"></i>
              <p>
                Payments
              </p>
            </a>
          </li>

          <li class="nav-header">Leads</li>

          <li class="nav-item" [routerLink]="['/dashboard/leads']"  *ngIf="user.role !== 'sales'">
            <a  class="nav-link">
              <i class="nav-icon fas fa-calendar-alt"></i>
              <p>
                Create Lead

              </p>
            </a>
          </li>
          <li class="nav-item" [routerLink]="['/dashboard/leads/manage']" *ngIf="user.role !== 'dataentry'">
            <a  class="nav-link">
              <i class="nav-icon far fa-image"></i>
              <p>
                Manage Lead
              </p>
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </aside>


  <router-outlet></router-outlet>



  <footer class="main-footer">
    <strong>Developed By: <a href="https://ankitarima.github.io/" target="_blank" > AnkitArima</a>.</strong>
    <div class="float-right d-none d-sm-inline-block">
      <b>Version</b> 1.6.5
    </div>
  </footer>
</div>
